import gql from 'graphql-tag'

export default gql`
  mutation managePod($podId: Int, $adminIds: [Int!], $name: String) {
    managePod(input: { podId: $podId, adminIds: $adminIds, name: $name }) {
      pod {
        rid
        name
        admins {
          rid
          name
          email
          link
          isLendingManager
          isAccountManager
          isRelationshipManager
        }
      }
    }
  }
`
